/* eslint-disable prefer-arrow-callback,no-var,comma-dangle,prefer-destructuring,vars-on-top,prefer-template,no-param-reassign,max-len */
(function setupBreakingBar() {
  var BREAKING_BAR_ELEMENT_SELECTOR = 'section.tc_breakingbar';
  var BREAKING_BAR_ARTICLE_ELEMENT_SELECTOR = 'li.tc_breakingbar__item';
  var BREAKING_BAR_BUTTON_ELEMENT_SELECTOR = '.tc_breakingbar__button';

  var HAS_SEEN_KEY = 'has_seen_breaking';

  var NEW_BREAKING_BAR_TIMER_INTERVAL = 25000;

  var urlDataElement = '';

  function getValueFromStorage(key) {
    return sessionStorage.getItem(key);
  }

  function setValueInStorage(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('TV2BreakingBar: Could not add key (' + key + ') to store');
    }
  }

  function getSeenArticleIds() {
    var seenIdsString = getValueFromStorage(HAS_SEEN_KEY);

    if (!seenIdsString) {
      return [];
    }

    return JSON.parse(seenIdsString);
  }

  function getAllArticleIdsFromDOM() {
    var articles = document.querySelectorAll(BREAKING_BAR_ARTICLE_ELEMENT_SELECTOR);

    var ids = [];

    var n;
    for (n = 0; n < articles.length; n += 1) {
      if (articles[n].id) {
        ids.push(articles[n].id);
      }
    }

    return ids;
  }

  function updateSeenBreakingIds() {
    var newIds = getAllArticleIdsFromDOM();

    if (newIds && newIds.length > 0) {
      var previousIds = getSeenArticleIds();

      var allIds = newIds.concat(previousIds);

      var idString = JSON.stringify(allIds);

      setValueInStorage(HAS_SEEN_KEY, idString);
    }
  }

  function hideBreakingBar(breakingBar) {
    if (breakingBar) {
      breakingBar.innerHTML = '';
      breakingBar.setAttribute('hidden', 'hidden');
    }
  }

  function showBreakingBar(breakingBar) {
    if (breakingBar) {
      breakingBar.removeAttribute('hidden');
    }
  }

  function closeBreakingBar(breakingBar) {
    updateSeenBreakingIds();

    hideBreakingBar(breakingBar);
  }

  function breakingLinkClickHandler() {
    updateSeenBreakingIds();
  }

  function setupBreakingBarLinks(links) {
    var n;
    for (n = 0; n < links.length; n += 1) {
      links[n].addEventListener('click', breakingLinkClickHandler);
    }
  }

  function attachListenersToBreakingBar(breakingBar) {
    var breakingBarCloseButton = breakingBar.querySelector(BREAKING_BAR_BUTTON_ELEMENT_SELECTOR);

    if (breakingBarCloseButton) {
      breakingBarCloseButton.addEventListener('click', closeBreakingBar.bind(null, breakingBar));
    }

    var breakingBarArticleLinks = breakingBar.querySelectorAll(BREAKING_BAR_ARTICLE_ELEMENT_SELECTOR + ' a');

    if (breakingBarArticleLinks && breakingBarArticleLinks.length > 0) {
      setupBreakingBarLinks(breakingBarArticleLinks);
    }
  }

  function setupBreakingBarListeners() {
    var breakingBar = document.querySelector(BREAKING_BAR_ELEMENT_SELECTOR);

    if (breakingBar) {
      attachListenersToBreakingBar(breakingBar);
    }
  }

  function removeSeenArticles(html, filterIds) {
    var n;
    for (n = 0; n < filterIds.length; n += 1) {
      var seenArticle = html.getElementById(filterIds[n]);

      if (seenArticle) {
        seenArticle.parentNode.removeChild(seenArticle);
      }
    }
  }

  function getFilteredBreakingBarHtml(barHtml) {
    var seenIds = getSeenArticleIds();

    if (seenIds) {
      removeSeenArticles(barHtml, seenIds);
    }

    return barHtml;
  }

  function allBreakingArticlesAlreadyInBar(barHtml) {
    var currentBreakingArticleIds = getAllArticleIdsFromDOM();

    if (currentBreakingArticleIds) {
      removeSeenArticles(barHtml, currentBreakingArticleIds);
    }

    var breakingArticlesNotOnPage = barHtml.querySelector(BREAKING_BAR_ARTICLE_ELEMENT_SELECTOR);

    return !breakingArticlesNotOnPage || breakingArticlesNotOnPage.length < 1;
  }

  function parseHtmlString(htmlString) {
    var domParser = new DOMParser();
    return domParser.parseFromString(htmlString, 'text/html');
  }

  function getNewBreakingBarWithFilteredArticles(filteredHtml) {
    var htmlWithFilteredArticles = getFilteredBreakingBarHtml(filteredHtml);

    var newBreakingArticles = htmlWithFilteredArticles.querySelectorAll(BREAKING_BAR_ARTICLE_ELEMENT_SELECTOR);

    if (newBreakingArticles && newBreakingArticles.length > 0) {
      return htmlWithFilteredArticles.querySelector('section');
    }

    return null;
  }

  function insertNewBarHtmlOnPage(oldBar, newBar) {
    if (oldBar && newBar) {
      oldBar.outerHTML = newBar.outerHTML;
      showBreakingBar(oldBar);
    } else if (newBar) {
      var newBarInDOM = document.createElement('section');

      newBarInDOM.outerHTML = newBar.outerHTML;
      showBreakingBar(newBarInDOM);

      document.body.appendChild(newBarInDOM);
    }
  }

  function checkAndRenderNewBreakingBar(htmlResponse, isInitialPageLoad) {
    var oldBreakingBarElement = document.querySelector(BREAKING_BAR_ELEMENT_SELECTOR);

    var newBreakingBarHtml = parseHtmlString(htmlResponse);

    var htmlWithFilteredArticles = getFilteredBreakingBarHtml(newBreakingBarHtml);

    var newBreakingBarElement = getNewBreakingBarWithFilteredArticles(htmlWithFilteredArticles);

    if (!newBreakingBarElement) {
      hideBreakingBar(oldBreakingBarElement);
      return;
    }

    if (allBreakingArticlesAlreadyInBar(htmlWithFilteredArticles)) {
      if (isInitialPageLoad) {
        setupBreakingBarListeners();
        showBreakingBar(oldBreakingBarElement);
      }

      return;
    }

    insertNewBarHtmlOnPage(oldBreakingBarElement, newBreakingBarElement);

    setupBreakingBarListeners();
  }

  function getNewBreakingBarFromService() {
    urlDataElement = document.querySelector('[data-tv2-breaking-bar-url]') || urlDataElement;
    if (!urlDataElement) {
      // eslint-disable-next-line no-console
      console.warn('TV2BreakingBar: Could not find "tv2-breaking-bar-url"');
      return;
    }

    var newBreakingBarUrl = urlDataElement.dataset.tv2BreakingBarUrl;
    if (!newBreakingBarUrl) {
      return;
    }

    var xhr = new XMLHttpRequest();

    xhr.onload = function handleBreakingBarResponse() {
      if (this.status === 200 && this.response) {
        checkAndRenderNewBreakingBar(this.response, false);
      }
    };

    xhr.open('GET', newBreakingBarUrl);
    xhr.responseType = 'text';
    xhr.send();
  }

  function filterBreakingBarOnPageLoad() {
    var breakingBar = document.querySelector(BREAKING_BAR_ELEMENT_SELECTOR);

    if (breakingBar) {
      checkAndRenderNewBreakingBar(breakingBar.outerHTML, true);
    }
  }

  filterBreakingBarOnPageLoad();

  setInterval(getNewBreakingBarFromService, NEW_BREAKING_BAR_TIMER_INTERVAL);
}());
